import React from "react";
import { Button, Modal } from "react-bootstrap";

export const SuggestionDropDownModelPopup = ({
  key,
  onOpenModal,
  open,
  onCloseModal,
  headerText,
  timeOneClick,
  timeTwoClick,
  timeThreeClick,
  timeFourClick,
  timeFiveClick,
  timeSixClick,
  timeSevenClick,
  timeEightClick,
  timeNineClick,
  timeTenClick,
  timeTextOne,
  timeTextTwo,
  timeTextThree,
  timeTextFour,
  timeTextFive,
  timeTextSix,
  timeTextSeven,
  timeTextEight,
  timeTextNine,
  timeTextTen,
  displayButton,
  displayButtonTwo,
  displayButtonThree,
  displayButtonFour,
  displayButtonFive,
  displayButtonSix,
  status,
  onSubmit,
}) => {
  return (
    <React.Fragment key={key}>
      <i
        className="ml-2 fa fa-angle-down"
        aria-hidden="true"
        onClick={onOpenModal}
      ></i>

      {/* <Modal
        open={open}
        onClose={onCloseModal}
        center
        classNames={{
          overlay: "onBoarding-CustomOverlay-request-accept-cancelled",
          modal: "reservation-vendor-model-popup",
          closeButton: "onBoarding-Custom-CloseButtonCalling",
          animationIn: "onBoardingCustomEnterAnimation",
          animationOut: "onBoardingCustomLeaveAnimation",
        }}
        animationDuration={1000}
      > */}
      {/* <Modal
        isOpen={open}
        onRequestClose={onCloseModal}
        style={customStyles}
        className="reservation-vendor-model-popup"
        contentLabel="Example Modal"
        ariaHideApp={false}
      >
        <div>
          <div className="reservation-vendor-model-popup-header">
            <Image
              src={require("../../../../../assets/images/ActionImages/backbuttonnew.png")}
              alt="back button"
              title="Back Button"
              fluid
              onClick={onCloseModal}
            />
            <h4>{headerText}</h4>
          </div>
          <hr />
          <div className="reservation-vendor-model-popup-bodybox">
            <ul
              type="none"
              className="reservation-vendor-model-popup-bodybox-ul"
            >
              <li onClick={timeOneClick}>{timeTextOne}</li>
              <li onClick={timeTwoClick}>{timeTextTwo}</li>
              <li onClick={timeThreeClick}>{timeTextThree}</li>
              {displayButton === true ? null : (
                <li onClick={timeFourClick}>{timeTextFour}</li>
              )}
              {displayButtonTwo === true ? null : (
                <li onClick={timeFiveClick}>{timeTextFive}</li>
              )}
              <li onClick={timeSixClick}>{timeTextSix}</li>
              {displayButtonThree === true ? (
                <li onClick={timeSevenClick}>{timeTextSeven}</li>
              ) : null}
              {displayButtonFour === true ? (
                <li onClick={timeEightClick}>{timeTextEight}</li>
              ) : null}
              {displayButtonFive === true ? (
                <li onClick={timeNineClick}>{timeTextNine}</li>
              ) : null}
              {displayButtonSix === true ? (
                <li onClick={timeTenClick}>{timeTextTen}</li>
              ) : null}
            </ul>
          </div>
        </div>
      </Modal> */}
      <Modal
        show={open}
        onHide={onCloseModal}
        backdrop="static"
        keyboard={false}
        centered
        className="enStatusListModal"
        size="sm"
      >
        <Modal.Header className="border-0" closeButton>
          <Modal.Title className="f24_700_HelveticaNeue">
            Ticket / Issue Status
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div className="pb-4 f16-500">
            Select one relevant option from below
          </div>
          <ul type="none" className="enStatusList">
            <li
              className={`${status === 0 ? "active" : ""}`}
              onClick={timeOneClick}
            >
              {timeTextOne}
            </li>
            <li
              className={`${status === 1 ? "active" : ""}`}
              onClick={timeTwoClick}
            >
              {timeTextTwo}
            </li>
            <li
              className={`${status === 2 ? "active" : ""}`}
              onClick={timeThreeClick}
            >
              {timeTextThree}
            </li>
            {displayButton === true ? null : (
              <li
                className={`${status === 3 ? "active" : ""}`}
                onClick={timeFourClick}
              >
                {timeTextFour}
              </li>
            )}
            {displayButtonTwo === true ? null : (
              <li
                className={`${status === 4 ? "active" : ""}`}
                onClick={timeFiveClick}
              >
                {timeTextFive}
              </li>
            )}
            <li
              className={`${status === 5 ? "active" : ""}`}
              onClick={timeSixClick}
            >
              {timeTextSix}
            </li>
            {displayButtonThree === true ? (
              <li
                className={`${status === 6 ? "active" : ""}`}
                onClick={timeSevenClick}
              >
                {timeTextSeven}
              </li>
            ) : null}
            {displayButtonFour === true ? (
              <li
                className={`${status === 7 ? "active" : ""}`}
                onClick={timeEightClick}
              >
                {timeTextEight}
              </li>
            ) : null}
            {displayButtonFive === true ? (
              <li
                className={`${status === 8 ? "active" : ""}`}
                onClick={timeNineClick}
              >
                {timeTextNine}
              </li>
            ) : null}
            {displayButtonSix === true ? (
              <li
                className={`${status === 9 ? "active" : ""}`}
                onClick={timeTenClick}
              >
                {timeTextTen}
              </li>
            ) : null}
          </ul>
          <div className="py-4 d-flex align-items-center">
            <Button
              variant="outline-secondary"
              className="btn-lg mr-4 px-5 btn150px"
              onClick={onCloseModal}
            >
              Cancel
            </Button>
            <Button
              variant="danger"
              onClick={onSubmit}
              className={`btn-lg px-5 btn150px `}
            >
              Confirm
            </Button>
          </div>
        </Modal.Body>
      </Modal>
    </React.Fragment>
  );
};
